import React, { memo, useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  sidebarSetStateValue,
  sidebarTypeSet,
} from "../../../redux/actions/sidebarActions";
import { loanDrilldownSidebarTypes } from "../../../constants/enums/loanDrilldownScreenSidebarOptions";
import { Button } from "@mui/material";
import { AddCardOutlined } from "@mui/icons-material";

/**
 * Example Type
 * loanDrilldownSidebarTypes.ADD_EDIT_THIRD_PARTY_FEES
 */
const LoanDrilldownButtonAddEntity = memo(({ size = "small", sx }) => {
  const dispatch = useDispatch();

  const onAdd = useCallback(() => {
    dispatch(sidebarTypeSet(loanDrilldownSidebarTypes.ADD_EDIT_ENTITY));
    dispatch(sidebarSetStateValue(null));
  }, [dispatch]);

  return (
    <Button
      sx={sx}
      size={size}
      startIcon={<AddCardOutlined className="thin" />}
      onClick={onAdd}
    >
      Add Entity
    </Button>
  );
});
export default LoanDrilldownButtonAddEntity;
